import { useGet } from './useHttpHooks';
import { ArticleListItemModel } from '../types';

const useGetTopArticles = () =>
    useGet<ArticleListItemModel[]>('/api/articles/top-articles', {
        errorMessage: 'GET /api/articles/top-articles failed'
    });

export default useGetTopArticles;
